// dependencies
import { List, Map } from "immutable";

const initialState = Map({
	signatureTemplates: Map(),
	signatureTemplatesList: List(),
});

export default function invitation(state = initialState, action) {
	switch (action.type) {
		case "SIGNATURETEMPLATES:GET@SUCCESS": {
			return state.setIn(["signatureTemplatesList"], action.response);
		}

		case "SIGNATURETEMPLATES:GETONE@SUCCESS": {
			return state.setIn(["signatureTemplates", action.response.id], action.response.data);
		}

		default:
			return state;
	}
}
